import 'svelte/internal/disclose-version';

Profile[$.FILENAME] = 'src/pages/Profile.svelte';

import * as $ from 'svelte/internal/client';
import api from "../lib/api.js";
import Avatar from "../components/Avatar.svelte";
import RestaurantCard from "../components/RestaurantCard.svelte";
import ReviewCard from "../components/ReviewCard.svelte";
import EmptyState from "../components/EmptyState.svelte";
import Field from "../components/Field.svelte";
import { session, setUser } from "../lib/session.svelte.js";
import { prefs, setPrefs } from "../lib/prefs.svelte.js";
import { toastSuccess, toastError } from "../lib/toast.svelte.js";

var root = $.add_locations($.from_html(`<span class="warn svelte-1ukpeu1">unconfirmed</span>`), Profile[$.FILENAME], [[57, 41]]);
var root_1 = $.add_locations($.from_html(`<span class="badge svelte-1ukpeu1">admin</span>`), Profile[$.FILENAME], [[58, 43]]);
var root_2 = $.add_locations($.from_html(`<div class="grid svelte-1ukpeu1"></div>`), Profile[$.FILENAME], [[72, 6]]);
var root_3 = $.add_locations($.from_html(`<p class="note svelte-1ukpeu1">These are saved in this browser. They'll sync to your account as you use the site.</p> <div class="grid svelte-1ukpeu1"></div>`, 1), Profile[$.FILENAME], [[78, 6], [79, 6]]);
var root_4 = $.add_locations($.from_html(`<div class="list svelte-1ukpeu1"></div>`), Profile[$.FILENAME], [[89, 6]]);
var root_5 = $.add_locations($.from_html(`<div class="grid svelte-1ukpeu1"></div>`), Profile[$.FILENAME], [[99, 6]]);
var root_6 = $.add_locations($.from_html(`<button type="button"> </button>`), Profile[$.FILENAME], [[123, 14]]);
var root_7 = $.add_locations($.from_html(`<button type="button"> </button>`), Profile[$.FILENAME], [[134, 14]]);

var root_8 = $.add_locations($.from_html(`<div class="settings svelte-1ukpeu1"><form class="panel svelte-1ukpeu1"><h2 class="svelte-1ukpeu1">Your name</h2> <!> <button class="primary svelte-1ukpeu1" type="submit"> </button></form> <div class="panel svelte-1ukpeu1"><h2 class="svelte-1ukpeu1">How the site behaves</h2> <p class="hint svelte-1ukpeu1">These are remembered in this browser, and on your account so other devices match.</p> <div class="row svelte-1ukpeu1"><span>Theme</span> <div class="pills svelte-1ukpeu1"></div></div> <div class="row svelte-1ukpeu1"><span>Default sort</span> <div class="pills svelte-1ukpeu1"></div></div> <div class="row svelte-1ukpeu1"><span>Recent searches</span> <button type="button" class="clear svelte-1ukpeu1"> </button></div></div></div>`), Profile[$.FILENAME], [
	[
		108,
		4,
		[
			[109, 6, [[110, 8], [112, 8]]],
			[
				115,
				6,
				[
					[116, 8],
					[117, 8],
					[119, 8, [[120, 10], [121, 10]]],
					[130, 8, [[131, 10], [132, 10]]],
					[139, 8, [[140, 10], [141, 10]]]
				]
			]
		]
	]
]);

var root_9 = $.add_locations($.from_html(`<header class="profile-head svelte-1ukpeu1"><!> <div><h1 class="svelte-1ukpeu1"> </h1> <p class="svelte-1ukpeu1"> <!> <!></p></div></header> <nav class="tabs svelte-1ukpeu1"><button> </button> <button> </button> <button>Recently viewed</button> <button>Settings</button></nav> <!>`, 1), Profile[$.FILENAME], [
	[52, 2, [[54, 4, [[55, 6], [56, 6]]]]],
	[63, 2, [[64, 4], [65, 4], [66, 4], [67, 4]]]
]);

const $$css = {
	hash: 'svelte-1ukpeu1',
	code: '\n  .profile-head.svelte-1ukpeu1 { display: flex; align-items: center; gap: 18px; padding: 40px 0 24px; }\n  h1.svelte-1ukpeu1 { font-size: 1.8rem; }\n  .profile-head.svelte-1ukpeu1 p:where(.svelte-1ukpeu1) { margin: 5px 0 0; color: var(--ink-soft); font-size: 0.92rem; display: flex; align-items: center; gap: 8px; }\n  .warn.svelte-1ukpeu1 { background: var(--mustard-soft); color: var(--ink); padding: 2px 9px; border-radius: var(--radius-pill); font-size: 0.74rem; }\n  .badge.svelte-1ukpeu1 { background: var(--sage-soft); color: var(--sage); padding: 2px 9px; border-radius: var(--radius-pill); font-size: 0.74rem; font-weight: 600; }\n\n  .tabs.svelte-1ukpeu1 { display: flex; gap: 6px; border-bottom: 1px solid var(--line); margin-bottom: 26px; overflow-x: auto; }\n  .tabs.svelte-1ukpeu1 button:where(.svelte-1ukpeu1) {\n    border: none;\n    background: none;\n    padding: 11px 15px;\n    font-size: 0.92rem;\n    font-weight: 600;\n    color: var(--ink-soft);\n    cursor: pointer;\n    border-bottom: 2px solid transparent;\n    white-space: nowrap;\n  }\n  .tabs.svelte-1ukpeu1 button.on:where(.svelte-1ukpeu1) { color: var(--accent); border-bottom-color: var(--accent); }\n\n  .grid.svelte-1ukpeu1 { display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 20px; }\n  .list.svelte-1ukpeu1 { background: var(--card); border: 1px solid var(--line); border-radius: var(--radius); padding: 4px 20px; }\n  .note.svelte-1ukpeu1 { color: var(--ink-faint); font-size: 0.87rem; margin: 0 0 14px; }\n\n  .settings.svelte-1ukpeu1 { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 20px; align-items: start; }\n  .panel.svelte-1ukpeu1 {\n    background: var(--card);\n    border: 1px solid var(--line);\n    border-radius: var(--radius);\n    padding: 22px;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n  }\n  .panel.svelte-1ukpeu1 h2:where(.svelte-1ukpeu1) { font-size: 1.06rem; }\n  .hint.svelte-1ukpeu1 { margin: -6px 0 0; font-size: 0.84rem; color: var(--ink-faint); line-height: 1.5; }\n\n  .row.svelte-1ukpeu1 { display: flex; align-items: center; justify-content: space-between; gap: 14px; flex-wrap: wrap; font-size: 0.9rem; }\n  .pills.svelte-1ukpeu1 { display: flex; gap: 6px; }\n  .pills.svelte-1ukpeu1 button:where(.svelte-1ukpeu1) {\n    border: 1px solid var(--line-strong);\n    background: none;\n    border-radius: var(--radius-pill);\n    padding: 6px 13px;\n    font-size: 0.82rem;\n    cursor: pointer;\n    text-transform: capitalize;\n  }\n  .pills.svelte-1ukpeu1 button.on:where(.svelte-1ukpeu1) { background: var(--accent); border-color: var(--accent); color: #fff; }\n\n  .clear.svelte-1ukpeu1 { border: none; background: none; color: var(--accent); cursor: pointer; font-size: 0.85rem; }\n  .primary.svelte-1ukpeu1 {\n    align-self: flex-start;\n    background: var(--accent);\n    color: #fff;\n    border: none;\n    font-weight: 600;\n    padding: 10px 22px;\n    border-radius: var(--radius-pill);\n    cursor: pointer;\n  }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function Profile($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Profile);
	$.append_styles($$anchor, $$css);

	let activity = $.tag($.state(null), 'activity');
	let tab = $.tag($.state("saved"), 'tab');
	let displayName = $.tag($.state(""), 'displayName');
	let savingName = $.tag($.state(false), 'savingName');

	$.user_effect(() => {
		if (!session.user) return;

		$.set(displayName, session.user.displayName, true);
		api.myActivity().then((data) => $.set(activity, data, true)).catch(() => {});
	});

	async function saveName(event) {
		event.preventDefault();
		$.set(savingName, true);

		try {
			const response = (await $.track_reactivity_loss(api.updateProfile({ displayName: $.get(displayName).trim() })))();

			(await $.track_reactivity_loss(setUser(response.user)))();
			toastSuccess("Name updated.");
		} catch(e) {
			toastError(e.message ?? "Couldn't save that.");
		} finally {
			$.set(savingName, false);
		}
	}

	const localFavorites = $.tag($.derived(() => (prefs.recentlyViewed ?? []).filter((item) => (prefs.favorites ?? []).includes(item.id))), 'localFavorites');
	var $$exports = { ...$.legacy_api() };
	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent_1 = ($$anchor) => {
			var fragment_1 = $.comment();
			var node_1 = $.first_child(fragment_1);

			{
				var consequent = ($$anchor) => {
					$.add_svelte_meta(
						() => EmptyState($$anchor, {
							icon: '👋',
							title: 'Log in to see your list',
							message: 'Your saved places live in this browser right now. Log in and they\'ll follow you anywhere.',
							action: { href: "/login", label: "Log in" }
						}),
						'component',
						Profile,
						44,
						4,
						{ componentTag: 'EmptyState' }
					);
				};

				$.add_svelte_meta(
					() => $.if(node_1, ($$render) => {
						if (session.loaded) $$render(consequent);
					}),
					'if',
					Profile,
					43,
					2
				);
			}

			$.append($$anchor, fragment_1);
		};

		var alternate_4 = ($$anchor) => {
			var fragment_3 = root_9();
			var header = $.first_child(fragment_3);
			var node_2 = $.child(header);

			$.add_svelte_meta(
				() => Avatar(node_2, {
					get user() {
						return session.user;
					},
					size: 64
				}),
				'component',
				Profile,
				53,
				4,
				{ componentTag: 'Avatar' }
			);

			var div = $.sibling(node_2, 2);
			var h1 = $.child(div);
			var text = $.child(h1, true);

			$.reset(h1);

			var p = $.sibling(h1, 2);
			var text_1 = $.child(p);
			var node_3 = $.sibling(text_1);

			{
				var consequent_2 = ($$anchor) => {
					var span = root();

					$.append($$anchor, span);
				};

				$.add_svelte_meta(
					() => $.if(node_3, ($$render) => {
						if (!session.user.emailVerified) $$render(consequent_2);
					}),
					'if',
					Profile,
					57,
					8
				);
			}

			var node_4 = $.sibling(node_3, 2);

			{
				var consequent_3 = ($$anchor) => {
					var span_1 = root_1();

					$.append($$anchor, span_1);
				};

				$.add_svelte_meta(
					() => $.if(node_4, ($$render) => {
						if ($.strict_equals(session.user.role, "admin")) $$render(consequent_3);
					}),
					'if',
					Profile,
					58,
					8
				);
			}

			$.reset(p);
			$.reset(div);
			$.reset(header);

			var nav = $.sibling(header, 2);
			var button = $.child(nav);
			let classes;
			var text_2 = $.child(button);

			$.reset(button);

			var button_1 = $.sibling(button, 2);
			let classes_1;
			var text_3 = $.child(button_1);

			$.reset(button_1);

			var button_2 = $.sibling(button_1, 2);
			let classes_2;
			var button_3 = $.sibling(button_2, 2);
			let classes_3;

			$.reset(nav);

			var node_5 = $.sibling(nav, 2);

			{
				var consequent_6 = ($$anchor) => {
					var fragment_4 = $.comment();
					var node_6 = $.first_child(fragment_4);

					{
						var consequent_4 = ($$anchor) => {
							var div_1 = root_2();

							$.add_svelte_meta(
								() => $.each(div_1, 21, () => $.get(activity).favorites, (restaurant) => restaurant.id, ($$anchor, restaurant) => {
									$.add_svelte_meta(
										() => RestaurantCard($$anchor, {
											get restaurant() {
												return $.get(restaurant);
											}
										}),
										'component',
										Profile,
										74,
										10,
										{ componentTag: 'RestaurantCard' }
									);
								}),
								'each',
								Profile,
								73,
								8
							);

							$.reset(div_1);
							$.append($$anchor, div_1);
						};

						var consequent_5 = ($$anchor) => {
							var fragment_6 = root_3();
							var div_2 = $.sibling($.first_child(fragment_6), 2);

							$.add_svelte_meta(
								() => $.each(div_2, 21, () => $.get(localFavorites), (item) => item.id, ($$anchor, item) => {
									{
										let $0 = $.derived(() => ({
											...$.get(item),
											ratingAverage: 0,
											reviewCount: 0,
											priceLevel: 2,
											tags: []
										}));

										$.add_svelte_meta(
											() => RestaurantCard($$anchor, {
												get restaurant() {
													return $.get($0);
												},
												compact: true
											}),
											'component',
											Profile,
											81,
											10,
											{ componentTag: 'RestaurantCard' }
										);
									}
								}),
								'each',
								Profile,
								80,
								8
							);

							$.reset(div_2);
							$.append($$anchor, fragment_6);
						};

						var alternate = ($$anchor) => {
							$.add_svelte_meta(
								() => EmptyState($$anchor, {
									icon: '⭐',
									title: 'Nothing saved yet',
									message: 'Tap the heart on any restaurant to keep it here.',
									action: { href: "/", label: "Find somewhere" }
								}),
								'component',
								Profile,
								85,
								6,
								{ componentTag: 'EmptyState' }
							);
						};

						$.add_svelte_meta(
							() => $.if(node_6, ($$render) => {
								if ($.get(activity)?.favorites?.length) $$render(consequent_4); else if ($.get(localFavorites).length) $$render(consequent_5, 1); else $$render(alternate, -1);
							}),
							'if',
							Profile,
							71,
							4
						);
					}

					$.append($$anchor, fragment_4);
				};

				var consequent_8 = ($$anchor) => {
					var fragment_9 = $.comment();
					var node_7 = $.first_child(fragment_9);

					{
						var consequent_7 = ($$anchor) => {
							var div_3 = root_4();

							$.add_svelte_meta(
								() => $.each(div_3, 21, () => $.get(activity).reviews, (review) => review.id, ($$anchor, review) => {
									$.add_svelte_meta(
										() => ReviewCard($$anchor, {
											get review() {
												return $.get(review);
											}
										}),
										'component',
										Profile,
										91,
										10,
										{ componentTag: 'ReviewCard' }
									);
								}),
								'each',
								Profile,
								90,
								8
							);

							$.reset(div_3);
							$.append($$anchor, div_3);
						};

						var alternate_1 = ($$anchor) => {
							$.add_svelte_meta(
								() => EmptyState($$anchor, {
									icon: '✍️',
									title: 'No reviews yet',
									message: 'Say something about a place you know well — a sentence is plenty.',
									action: { href: "/", label: "Pick a restaurant" }
								}),
								'component',
								Profile,
								95,
								6,
								{ componentTag: 'EmptyState' }
							);
						};

						$.add_svelte_meta(
							() => $.if(node_7, ($$render) => {
								if ($.get(activity)?.reviews?.length) $$render(consequent_7); else $$render(alternate_1, -1);
							}),
							'if',
							Profile,
							88,
							4
						);
					}

					$.append($$anchor, fragment_9);
				};

				var consequent_10 = ($$anchor) => {
					var fragment_12 = $.comment();
					var node_8 = $.first_child(fragment_12);

					{
						var consequent_9 = ($$anchor) => {
							var div_4 = root_5();

							$.add_svelte_meta(
								() => $.each(div_4, 21, () => $.get(activity).recentlyViewed, (restaurant) => restaurant.id, ($$anchor, restaurant) => {
									$.add_svelte_meta(
										() => RestaurantCard($$anchor, {
											get restaurant() {
												return $.get(restaurant);
											},
											compact: true
										}),
										'component',
										Profile,
										101,
										10,
										{ componentTag: 'RestaurantCard' }
									);
								}),
								'each',
								Profile,
								100,
								8
							);

							$.reset(div_4);
							$.append($$anchor, div_4);
						};

						var alternate_2 = ($$anchor) => {
							$.add_svelte_meta(
								() => EmptyState($$anchor, {
									icon: '🕘',
									title: 'Nothing here yet',
									message: 'Places you look at will show up here.'
								}),
								'component',
								Profile,
								105,
								6,
								{ componentTag: 'EmptyState' }
							);
						};

						$.add_svelte_meta(
							() => $.if(node_8, ($$render) => {
								if ($.get(activity)?.recentlyViewed?.length) $$render(consequent_9); else $$render(alternate_2, -1);
							}),
							'if',
							Profile,
							98,
							4
						);
					}

					$.append($$anchor, fragment_12);
				};

				var alternate_3 = ($$anchor) => {
					var div_5 = root_8();
					var form = $.child(div_5);
					var node_9 = $.sibling($.child(form), 2);

					$.add_svelte_meta(
						() => Field(node_9, {
							label: 'Display name',
							name: 'displayName',
							required: true,
							get value() {
								return $.get(displayName);
							},

							set value($$value) {
								$.set(displayName, $$value, true);
							}
						}),
						'component',
						Profile,
						111,
						8,
						{ componentTag: 'Field' }
					);

					var button_4 = $.sibling(node_9, 2);
					var text_4 = $.child(button_4, true);

					$.reset(button_4);
					$.reset(form);

					var div_6 = $.sibling(form, 2);
					var div_7 = $.sibling($.child(div_6), 4);
					var div_8 = $.sibling($.child(div_7), 2);

					$.add_svelte_meta(
						() => $.each(div_8, 20, () => ["system", "light", "dark"], (option) => option, ($$anchor, option) => {
							var button_5 = root_6();
							let classes_4;
							var text_5 = $.child(button_5, true);

							$.reset(button_5);

							$.template_effect(() => {
								classes_4 = $.set_class(button_5, 1, 'svelte-1ukpeu1', null, classes_4, { on: $.strict_equals(prefs.theme, option) });
								$.set_text(text_5, option);
							});

							$.delegated('click', button_5, function click_4() {
								return setPrefs({ theme: option });
							});

							$.append($$anchor, button_5);
						}),
						'each',
						Profile,
						122,
						12
					);

					$.reset(div_8);
					$.reset(div_7);

					var div_9 = $.sibling(div_7, 2);
					var div_10 = $.sibling($.child(div_9), 2);

					$.add_svelte_meta(
						() => $.each(
							div_10,
							20,
							() => [
								["rating", "Rating"],
								["reviews", "Reviews"],
								["newest", "Newest"]
							],
							([value, label]) => value,
							($$anchor, $$item) => {
								var $$array = $.derived(() => $.to_array($$item, 2));
								let value = () => $.get($$array)[0];

								value();

								let label = () => $.get($$array)[1];

								label();

								var button_6 = root_7();
								let classes_5;
								var text_6 = $.child(button_6, true);

								$.reset(button_6);

								$.template_effect(() => {
									classes_5 = $.set_class(button_6, 1, 'svelte-1ukpeu1', null, classes_5, { on: $.strict_equals(prefs.sort, value()) });
									$.set_text(text_6, label());
								});

								$.delegated('click', button_6, function click_5() {
									return setPrefs({ sort: value() });
								});

								$.append($$anchor, button_6);
							}
						),
						'each',
						Profile,
						133,
						12
					);

					$.reset(div_10);
					$.reset(div_9);

					var div_11 = $.sibling(div_9, 2);
					var button_7 = $.sibling($.child(div_11), 2);
					var text_7 = $.child(button_7);

					$.reset(button_7);
					$.reset(div_11);
					$.reset(div_6);
					$.reset(div_5);

					$.template_effect(() => {
						button_4.disabled = $.get(savingName);
						$.set_text(text_4, $.get(savingName) ? "Saving…" : "Save");
						$.set_text(text_7, `Clear (${prefs.recentSearches?.length ?? 0 ?? ''})`);
					});

					$.event('submit', form, saveName);

					$.delegated('click', button_7, function click_6() {
						return setPrefs({ recentSearches: [] });
					});

					$.append($$anchor, div_5);
				};

				$.add_svelte_meta(
					() => $.if(node_5, ($$render) => {
						if ($.strict_equals($.get(tab), "saved")) $$render(consequent_6); else if ($.strict_equals($.get(tab), "reviews")) $$render(consequent_8, 1); else if ($.strict_equals($.get(tab), "recent")) $$render(consequent_10, 2); else $$render(alternate_3, -1);
					}),
					'if',
					Profile,
					70,
					2
				);
			}

			$.template_effect(() => {
				$.set_text(text, session.user.displayName);
				$.set_text(text_1, `${session.user.email ?? ''} `);
				classes = $.set_class(button, 1, 'svelte-1ukpeu1', null, classes, { on: $.strict_equals($.get(tab), "saved") });
				$.set_text(text_2, `Saved (${$.get(activity)?.favorites?.length ?? 0 ?? ''})`);
				classes_1 = $.set_class(button_1, 1, 'svelte-1ukpeu1', null, classes_1, { on: $.strict_equals($.get(tab), "reviews") });
				$.set_text(text_3, `Reviews (${$.get(activity)?.reviews?.length ?? 0 ?? ''})`);
				classes_2 = $.set_class(button_2, 1, 'svelte-1ukpeu1', null, classes_2, { on: $.strict_equals($.get(tab), "recent") });
				classes_3 = $.set_class(button_3, 1, 'svelte-1ukpeu1', null, classes_3, { on: $.strict_equals($.get(tab), "settings") });
			});

			$.delegated('click', button, function click() {
				return $.set(tab, "saved");
			});

			$.delegated('click', button_1, function click_1() {
				return $.set(tab, "reviews");
			});

			$.delegated('click', button_2, function click_2() {
				return $.set(tab, "recent");
			});

			$.delegated('click', button_3, function click_3() {
				return $.set(tab, "settings");
			});

			$.append($$anchor, fragment_3);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if (!session.user) $$render(consequent_1); else $$render(alternate_4, -1);
			}),
			'if',
			Profile,
			42,
			0
		);
	}

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

$.delegate(['click']);